import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import React from 'react';
/**
 * A component that renders a dialog box after a resume is uploaded. It contains
 * a confirmation message and two buttons. The first button is used to cancel the
 * process and the second button is used to proceed with updating the Master Profile.
 * @param {{ handleProceed: function, handleCancel: function }} props
 * @return {ReactElement} - The rendered component.
 */
const UploadResumeNavigation = ({ handleProceed, handleCancel }) => {
    return (

        <Card className="otp-card-wrapper" variant="outlined">
            <CardContent>
                <Box>
                    <Stack justifyContent={'center'}>
                        <Box sx={{ textAlign: 'center' }} mb={3}>
                            <Typography className="title" mb={1} component="h5" sx={{ fontSize: "1.3rem", fontWeight: "bold" }} >
                                Your resume has been uploaded successfully
                                <br />
                            </Typography>
                            <Typography >Do you also want to update the Master Profile now?</Typography>
                        </Box>
                        <Stack direction={{ xs: 'column-reverse', md: 'row' }} alignItems={'center'} spacing={2.5}>
                            <Button fullWidth variant="outlined" size="medium" onClick={handleCancel}>No</Button>
                            <Button fullWidth variant="contained" size="medium" onClick={handleProceed}>Yes</Button>
                        </Stack>
                    </Stack>
                </Box>
            </CardContent>
        </Card>
    )
}
export default UploadResumeNavigation;
